import { Link } from 'react-router-dom';
import { useLanguage } from '../../shell/language-context';

// Catch-all route (CB-D2). Mirrors the website's not-found tone.
export function NotFoundScreen() {
  const { t } = useLanguage();
  return (
    <div className="card" style={{ padding: 40, textAlign: 'center' }}>
      <h1 style={{ marginTop: 0 }}>{t('notfound.title')}</h1>
      <p className="muted">{t('notfound.body')}</p>
      <Link to="/" className="btn" style={{ marginTop: 8 }}>
        {t('dc70.nav.home')}
      </Link>
    </div>
  );
}
